import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface AllowCopyPasteResponse {
  allowCopyPaste: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/config`;

  readonly allowCopyPaste = signal<boolean>(false);
  readonly allowCopyPasteLoaded = signal(false);

  private fetchPromise: Promise<boolean> | null = null;

  fetchAllowCopyPaste(): Promise<boolean> {
    if (this.fetchPromise) {
      return this.fetchPromise;
    }

    this.fetchPromise = new Promise((resolve, reject) => {
      this.http.get<AllowCopyPasteResponse>(`${this.apiUrl}/allow-copy-paste`).subscribe({
        next: (res) => {
          const val = res?.allowCopyPaste ?? false;
          this.allowCopyPaste.set(val);
          this.allowCopyPasteLoaded.set(true);
          resolve(val);
        },
        error: (err) => {
          this.allowCopyPaste.set(false);
          this.allowCopyPasteLoaded.set(true);
          resolve(false);
        },
      });
    });

    return this.fetchPromise;
  }
}
